import { useTranslation } from "react-i18next";
import { getPf } from "../../utils/conf";
import { cdnImg } from "../image/image-src";

export const ProductBannerPassIntroduction = () => {
  const { t } = useTranslation();
  const pf = getPf();
  return (
    <div className="ui-container mb-8 flex flex-col gap-[2.875rem] sm:mb-[7.5rem] sm:flex-row">
      <img
        className="h-auto w-full rounded-[25px] sm:max-w-[521px]"
        src={
          pf === "TRAVITY"
            ? cdnImg(
                "../../assets/images/pass-demo/banner-travity.png?format=webp",
              )
            : cdnImg("../../assets/images/pass-demo/banner.png?format=webp")
        }
        alt=""
        fetchPriority="high"
        loading="eager"
      />
      <div className="w-full content-center sm:min-w-[49rem]">
        <h1 className="mx-auto mb-4 w-[300px] text-center text-[18px] font-semibold leading-6 text-[#232323] sm:w-full sm:text-left sm:text-[2rem] sm:leading-[2.75rem]">
          {getPf() === "TRAVITY"
            ? t("The exciting start of your journey, with Travity.")
            : t("The exciting start of your journey, with Tamice.")}
        </h1>
        <p className="text-center text-[#5E6D77] sm:text-left">
          {t("Up to 65% off from New York to Niagara and Hawaii.")}
        </p>
      </div>
    </div>
  );
};
